export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    container: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        height: 'auto',
        cursor: 'pointer',
        padding: FOUNDATIONS.spacing_150,
        border_radius: FOUNDATIONS.border_150,
        ...STATE_TOKENS.container,
    },
    leftContent: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        width: 'fit-content',
        align_items: 'center',
        ...STATE_TOKENS.leftContent,
    },
    centerContent: {
        width: '100%',
        flex_grow: '1',
        ...STATE_TOKENS.centerContent,
    },
    rightContent: {
        display: 'flex',
        align_items: 'center',
        width: 'fit-content',
        ...STATE_TOKENS.rightContent,
    },
    checkedIcon: {
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_selected_bg_50,
        ...STATE_TOKENS.checkedIcon,
    },
    radioButton: {
        position: 'relative',
        border_radius: FOUNDATIONS.radius_comp_forms_radiobutton_radiussize,
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
        background_color: 'transparent',
        border_width: FOUNDATIONS.border_50,
        border_style: 'solid',
        border_color: FOUNDATIONS.color_neutral_border_150,
        ...STATE_TOKENS.radioButton,
    },
    radioButtonIcon: {
        left: '50%',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        background_color: 'transparent',
        width: '50%',
        height: '50%',
        border_radius: FOUNDATIONS.radius_1000,
        ...STATE_TOKENS.radioButtonIcon,
    },
});
//# sourceMappingURL=commonStyles.js.map